import apiConfig from "../../apiConfig";

export const validateDonationBandData = async (
	at,
	{
		Active_Status_Id,
		Donation_Band_Name_AR = "",
        Donation_Band_Name_EN = "",
		Donation_Band_Id
	}
) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Validate_Donation_Band_Data",
		{
			Active_Status_Id,
			Donation_Band_Name_AR,
			Donation_Band_Name_EN,
			Donation_Band_Id
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
